import React, { useEffect } from 'react';
import Table from '../../../modules/components/Table'
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AddEditUsers from './AddEditSalesman';
import firebase from "firebase";

export default function Index(props) {

    const [headCells, setHeadCells] = React.useState([]);
    const [headMobileCells, setHeadMobileCells] = React.useState([]);
    const [searchValue, setSearchValue] = React.useState("");
    const [searchCell, setSearchCell] = React.useState([]);
    const [displayInfo, setDisplayInfo] = React.useState([]);
    const [editCells, setEditCells] = React.useState([]);
    const [addCells, setAddCells] = React.useState([]);
    const [addCellsName, setAddCellsName] = React.useState([]);
    const matches = useMediaQuery(theme => theme.breakpoints.up('sm'));

    useEffect(() => {

        setHeadCells([
            { id: 'id', label: 'Saleman Id' },
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
            { id: 'user_redeem_time', label: 'Redeem Times' },
            { id: 'point_users', label: 'Points' },
            { id: 'role', label: 'Role' },
            { id: 'user_level', label: 'Level' },
            { id: 'phone', label: 'Phone' },
            { id: 'status_users', label: 'Status' },
        ])

        setHeadMobileCells([
            { id: 'id', label: 'Saleman Id' },
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
        ])
    
        setSearchCell([
            { id: 'id', label: 'Saleman Id' },
            { id: 'phone', label: 'Phone' },
            { id: 'email', label: 'Email' },
        ])

        setDisplayInfo([
            { id: 'id', label: 'Saleman Id' },
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
            { id: 'user_redeem_time', label: 'Redeem Times' },
            { id: 'point_users', label: 'Points' },
            { id: 'role', label: 'Role' },
            { id: 'user_level', label: 'Level' },
            { id: 'created', label: 'Registered' },
            { id: 'email', label: 'Email' },
            { id: 'phone', label: 'Phone' },
            { id: 'status_users', label: 'Status' },
            { id: 'document', label: 'Document verification' },
        ])

        setEditCells([
            { id: 'id', label: 'Saleman Id' },
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
            { id: 'user_redeem_time', label: 'Redeem Times' },
            { id: 'email', label: 'Email' },
            { id: 'point_users', label: 'Points' },
            { id: 'status_users', label: 'Status' },
            { id: 'address', label: 'Address' },
        ])

        setAddCells([
            { id: 'first_name', label: 'First Name' },
            { id: 'last_name', label: 'Last Name' },
            { id: 'user_redeem_time', label: 'Redeem Times' },
            { id: 'email', label: 'Email' },
            { id: 'point_users', label: 'Points' },
            { id: 'status_users', label: 'Status' },
            { id: 'address', label: 'Address' },
        ])

        setAddCellsName({ 
            store_id: '',
            first_name: '',
            last_name: '',
            point_users: "0",
            created: firebase.database.ServerValue.TIMESTAMP,
            updated: firebase.database.ServerValue.TIMESTAMP,
            email: '',
            phone: '',
            status_users: '',
            role: '',
            user_redeem_time: "0"
         })
    
        setSearchValue("phone")
        
    }, []);

    return (
    <Grid>
        <Table 
            {...props}
            customizeDialog={AddEditUsers}
            control={true}
            orderBy="created" 
            data="salesman" 
            role="salesman"
            addItemButton={false}
            addItemText="Add Salesman"
            addItemIcon={<AddCircleIcon/>}
            addCells={addCells}
            addCellsName={addCellsName}
            folder_data="salesman_zone"
            displayInfo={displayInfo}
            editCells={editCells}
            matches={matches}
            headCells={matches ? headCells : headMobileCells} 
            searchValue={searchValue} 
            searchCell={searchCell}/>
    </Grid>
    )

}
  